import React from "react";
import { CustomButton } from "./CustomButton";
import { ButtonProps } from "@mui/material";

export const GradientButton = ({ children, ...props }: ButtonProps) => {
  return (
    <CustomButton
      customSize="fit"
      type="submit"
      customColor="#F16300"
      customGradientColor="#FE8836"
      {...props}
    >
      {children}
    </CustomButton>
  );
};
